import O1HD, { modules } from "../../../../engines/gameEngine";
import PromiseUtil from "../../../../engines/libs/PromiseUtil";
import utilsModel from "../../../../engines/libs/utilsModel";
import { UI_Z_INDEX } from "../../../../engines/modules/uiModule";
import ShowPicturePage from "../../../../O1ModuleRes/control/Page/ShowPicturePage";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../../normalMode/BundleResourceConfig";
import { backPackEventMap } from "../../../normalMode/config/BackpackEventConfig";
import { getOneNormalEventNewById } from "../../../normalMode/config/normalEvent_NewConfig";
import NormalGameManager from "../../../normalMode/manager/NormalGameManager";
import { WeChatChitChatChoose, WeChatChitChatParam, WeChatSaveChat } from "../../../normalMode/manager/WeChatConst";

const {ccclass, property} = cc._decorator;

@ccclass
export default class weChatPrefab extends cc.Component {

    @property({type:cc.Node,displayName:"红包节点"})
    redPacketNode:cc.Node = null;

    @property({type:cc.Node,displayName:"转账节点"})
    transferNode:cc.Node = null;

    @property({type:cc.Node,displayName:"文字节点"})
    chatNode:cc.Node = null;

    @property({type:cc.Node,displayName:"头像节点"})
    headNode:cc.Node = null;

    @property({type:cc.Node,displayName:"图片节点"})
    spNode:cc.Node = null;
    @property({type:cc.Node,displayName:"ad 广告"})
    adNode : cc.Node = null;

    sp:cc.Sprite = null;

    spMaxRadio:number = 300;

    moneyNum:number = null;

    @property({type:cc.Node,displayName:"红包视频节点"})
    redPacketVideo:cc.Node = null;

    @property({type:cc.Node,displayName:"转账视频节点"})
    transferVideo:cc.Node = null;

    @property(cc.Node)
    nodeGoods: cc.Node = null;

    /** 物品 */
    private goods: any[] = [];
    /** 聊天记录索引 */
    private recordListIdx = -1;
    private _parent: any = null;
    private bOldData = false;


    onLoad(){
        this.spNode.on("touchend",this.onTouchPic,this);
    }

    choose:WeChatChitChatChoose = null;

    bindChoose(choose:WeChatChitChatChoose){
        this.choose = choose;
    }

    setData(_parent, recordListIdx: number, bOldData: boolean) {
        this.bOldData = bOldData;
        this._parent = _parent;
        this.recordListIdx = recordListIdx;
    }

    redPacketFun:()=>void = null;

    //设置红包的点击回调
    setRedPacketFun(redPacketFun:()=>void){
        this.redPacketFun = redPacketFun;
    }

    onChat(
        chat:string | cc.SpriteFrame
        , isMeAsk:boolean = false 
        , watchAdFlag : boolean = false
        , param?: WeChatChitChatParam
        , chitChat: WeChatSaveChat = null
        // , bRecv?: boolean
    ) {
        this.nodeGoods && (this.nodeGoods.active = false);
        this.sp = this.spNode && this.spNode.getComponent(cc.Sprite);
        if(chat instanceof cc.SpriteFrame){
            // 是图片 直接显示图片
            this.setSp(chat , watchAdFlag );
        }else{
            // 不是图片 解析内容然后显示
            if(chat.includes("红包：")){
                this.setRedPacket(isMeAsk);
                let moneyNum = Number(chat.substring(3));
                this.moneyNum = moneyNum;
            }else if(chat.includes("转账：")){
                let moneyNum = Number(chat.substring(3));
                this.moneyNum = moneyNum;
                this.setTransfer(moneyNum,isMeAsk);
            }else{
                if (param && param.goods && param.goods.length > 0) {
                    this.goods = param.goods;
                    this.setShowGoods(
                        param
                        , isMeAsk
                        , (chitChat && chitChat.bRecv) || param.yetRecv
                        , chitChat && chitChat.bLookAd
                    );
                } else {
                    this.setChat(chat);
                }
            }
        }
    }

    async setShowGoods(
        param: WeChatChitChatParam
        , isMe:boolean = false
        , bRecv?: boolean
        , bLookAd?: boolean
    ){
        this.chatNode.active = false;
        this.redPacketNode.active = false;
        this.transferNode.active = false;
        this.spNode.active = false;
        if (!this.nodeGoods) {
            return;
        }
        this.nodeGoods.active = true;

        let chatBg: cc.Node = this.nodeGoods.getChildByName("chatBG");
        let btnRecv = chatBg.getChildByName("nodeButton")?.getChildByName('btnRecv')?.getComponent(cc.Button);
        let redPacketVideo = this.nodeGoods.getChildByName("redGoodstVideo");

        if (btnRecv && bRecv) {
            btnRecv.interactable = false;
        }
        for (let i = 0; i < 2; i++) {
            let nodeGoods = chatBg.getChildByName('nodeGoods'+(i+1));
            if (i > param.goods.length-1) {
                nodeGoods.active = false;
                continue;
            }
            nodeGoods.active = true;
            let good = param.goods[i];
            // 
            // let sprGoodsBg = nodeGoods.getChildByName('sprGoodsBg').getComponent(cc.Sprite);
            let sprGoodsGold = nodeGoods.getChildByName('sprGoodsGold').getComponent(cc.Sprite);
            let sprGoods = nodeGoods.getChildByName('sprGoods').getComponent(cc.Sprite);
            let labelCount = nodeGoods.getChildByName('labelCount').getComponent(cc.Label);
            let sprSelect = nodeGoods.getChildByName('sprSelect');
            let goodsCount = '';
            if (good.coin) {
                goodsCount = good.coin;
                sprGoods.node.active = false;
                sprGoodsGold.node.active = true;
                // sprGoodsBg
            } else {
                goodsCount = good.count;
                sprGoodsGold.node.active = false;
                sprGoods.node.active = true;
                let gwidth = sprGoods.node.width;
                let gheight = sprGoods.node.height;
                
                let goodsConfig = backPackEventMap()[good.id];
                let spPath:string = goodsConfig.spPath;
                if(spPath && spPath != ""){
                    let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
                    bundle.load(`backpackAssets/objSp/${spPath}`
                    , cc.SpriteFrame
                    , (err,imgs:cc.SpriteFrame)=>{
                        if(err){
                            console.log(err);
                        }else{
                            sprGoods.spriteFrame = imgs;
                            let scale = Math.min(gwidth / sprGoods.node.width, gheight / sprGoods.node.height);
                            sprGoods.node.scale = scale;
                        }
                    });
                }
            }
            labelCount.string = '×' + goodsCount;
            sprSelect && (sprSelect.active = bRecv ? true : false);
        }
        if (redPacketVideo) {
            let bLAd = param.recvGoodsAd ? true : false;
            if (bLAd && bLookAd) {
                bLAd = false;
            }
            redPacketVideo.active = bLAd;
            if (bLAd) {
                PromiseUtil.nextFrame().then(()=> {
                    chatBg.getComponent(cc.Layout).updateLayout();
                    redPacketVideo.width = chatBg.width;
                    redPacketVideo.children.forEach((vn)=> {
                        vn.getComponent(cc.Widget).updateAlignment();
                    })
                });
            }
        }
    }

    setTransfer(moneyNum:number,isMe:boolean = false){
        this.chatNode.active = false;
        this.redPacketNode.active = false;
        this.transferNode.active = true;
        this.spNode.active = false;
        let moneyLb:cc.Label = this.transferNode.getChildByName("moneyLb").getComponent(cc.Label);
        moneyLb.string = moneyNum.toString();
        this.node.height = 157;
        if(!isMe && this.transferVideo){
            this.transferVideo.active = true;
        }
        if(this.choose?.watchAdFlag == false){
            this.transferVideo.active = false;
        }
    }

    setRedPacket(isMe:boolean = false){
        this.chatNode.active = false;
        this.transferNode.active = false;
        this.redPacketNode.active = true;
        this.spNode.active = false;
        this.node.height = 157;
        if(!isMe && this.redPacketVideo){
            this.redPacketVideo.active = true;
        }
    }

    setChat(str:string){
        this.chatNode.active = true;
        this.redPacketNode.active = false;
        this.transferNode.active = false;
        this.spNode.active = false;
        let chatBg:cc.Node = this.chatNode.getChildByName("chatBG");
        let chatStr:cc.Label = chatBg.getChildByName("lb").getComponent(cc.Label);
        let chatS:string = "";
        for(let i =0;i<str.length;i++){
            chatS += str[i];
            if((i + 1)%11 == 0){
                chatS += "\n";
            }
        }
        chatStr.string = chatS;
        let row:number = Math.ceil(str.length / 11);
        let lbHeight:number = row * chatStr.lineHeight + 13;
        let bgHeight:number = lbHeight + 20;
        let nodeHeight:number = bgHeight + 10;
        chatBg.height = bgHeight;
        this.node.height = nodeHeight;
        // console.log(nodeHeight);
    }

    setSp(spr:cc.SpriteFrame,watchAdFlag : boolean){
        if(!this.spNode){
            return;
        }
        this.sp = this.spNode && this.spNode.getComponent(cc.Sprite);
        this.chatNode.active = false;
        this.redPacketNode.active = false;
        this.transferNode.active = false;
        this.spNode.active = true;
        let width = spr.getTexture().width;
        let height = spr.getTexture().height;

        let max = Math.max(width,height);
        let radio:number = 1;
        if(max > this.spMaxRadio){
            radio = this.spMaxRadio / max;
        }
        this.sp.spriteFrame = spr;
        this.scheduleOnce(()=>{
            this.spNode.width = width * radio;
            this.spNode.height =  height * radio;
        });

        if ( watchAdFlag ) {
            this.adNode.active = true;
            this.adNode.width = width * radio;
            this.adNode.height = height * radio;
            if ( this.adNode.getChildByName("videoRed") ) {
                this.adNode.getChildByName("videoRed").x = width * radio / 2;
                this.adNode.getChildByName("videoRed").y = -height * radio / 2;
            }
        }

        let nHeight = height * radio;
        this.node.height = nHeight + 10;

    }

    onBtnAd(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.adNode.active = false;
            if(this.choose){
                let chooseParam = this.choose.param;
                let openEvent = chooseParam["openEvent"];
                if(openEvent!= null){
                    let event = getOneNormalEventNewById(openEvent);
                    if(event && event.type == "2"){
                        NormalGameManager._instance.addOneEvent(openEvent);
                    }
                }
            }
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
        },()=>{

        },"对话图片解锁");
    }

    async onTouchPic() {
        // 点击图片
        if(!this.spNode){
            return;
        }
        let page = await modules().uiControlModule.OpenPage("gamePage/ShowPicturePage", UI_Z_INDEX.DIALOG)
        page.getComponent(ShowPicturePage).init(this.sp);

    }

    changeHead(headSpretie:cc.SpriteFrame){
        if(this.headNode){
            this.headNode.getComponent(cc.Sprite).spriteFrame = headSpretie;
        }
    }

    //点击红包
    onClickMoneyVideo(e:cc.Event.EventTouch){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let targetNode:cc.Node = e.target;
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.transferVideo.active = false;
            this.redPacketVideo.active = false;
            O1HD.getServices().userSrv.setCoins(this.moneyNum,true,targetNode);
            this.redPacketFun && this.redPacketFun();
        },()=>{

        },null,"聊天看广告获得钱")
    }

    onClickRecvGoods(event: cc.Event.EventTouch) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let targetNode = event.target;
        this.recvGoods(targetNode);
    }

    recvGoods(targetNode: cc.Node) {
        let button: cc.Button = targetNode.getComponent(cc.Button);
        button.interactable = false;

        let chatBg: cc.Node = this.nodeGoods.getChildByName("chatBG");
        for (let i = 0; i < 2; i++) {
            let nodeGoods = chatBg.getChildByName('nodeGoods'+(i+1));
            if (!nodeGoods.active) {
                continue;
            }
            let sprSelect = nodeGoods.getChildByName('sprSelect');
            sprSelect.active = true;
        }

        if (!this.goods) {
            return;
        }
        this.goods.forEach((v)=> {
            if (v.coin) {
                O1HD.getServices().userSrv.setCoins(v.coin, true);
            } else {
                if(v.prestige){
                    let gameManager = NormalGameManager._instance;
                    gameManager.addExp(v.prestige);
                    // O1HD.getModules().uiControlModule.showMessageBox(`物品${backPackEventMap()[v.id].name}已转换为${v.prestige}声望值`);
                }else{
                    NormalGameManager._instance.onPushGoods(v.id, v.count);
                }
            }
        });

        if (this._parent && utilsModel.isValidNumberValue(this.recordListIdx)) {
            if (this._parent.recvGoodsSuccess) {
                this._parent.recvGoodsSuccess(this.recordListIdx, this.bOldData);
            }
        }
    }

    onClickGoodsVideo(e:cc.Event.EventTouch) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let targetNode:cc.Node = e.target;
        utilsModel.loadAndShowVideoAdTrans(()=>{
            targetNode.active = false;

            if (this._parent && utilsModel.isValidNumberValue(this.recordListIdx)) {
                if (this._parent.lookGoodsAdSuccess) {
                    this._parent.lookGoodsAdSuccess(this.recordListIdx, this.bOldData);
                }
                let chatBg: cc.Node = this.nodeGoods.getChildByName("chatBG");
                let btnRecv = chatBg.getChildByName("nodeButton")?.getChildByName('btnRecv');
                this.recvGoods(btnRecv);
            }
        },()=>{

        },null,"聊天看广告获得物品")
    }


}
